
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { TeacherStatusResponse } from "../../models/dtos";

export const teacherStatusesApi = createApi({
  reducerPath: 'teacherStatusesApi',
  baseQuery: baseAuthQuery('TeacherStatuses'),
  tagTypes: ['TeacherStatus'],
  endpoints: (builder) => ({
    getTeacherStatuses: builder.query<ApiResponse<TeacherStatusResponse[]>, void>({
      query: () => "",
      providesTags: ['TeacherStatus'],
    }),
    getTeacherStatusById: builder.query<ApiResponse<TeacherStatusResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['TeacherStatus'],
    }),
    updateTeacherStatus: builder.mutation<ApiResponse<TeacherStatusResponse>, Partial<TeacherStatusResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['TeacherStatus'],
    }),
    deleteTeacherStatus: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['TeacherStatus'],
    }),
  }),
});
